import React, { FC } from "react";
import { Typography } from "@mui/material";
import PetCard from "../../../../components/PetCard/PetCard";
import SupportModalHeader from "../../../../components/SupportModalHeader/SupportModalHeader";
import { IPetItemResponse } from "../../../../services/pet-list/pet-list.interface";
import { usePetStore } from "../../../../hooks/redux-hooks/pet-store/pet-store.service";
import { COPY } from "../constants";
import { Checkbox } from "@mui/material";
import { CheckboxCheckedIcon, CheckboxUncheckedIcon } from "../../../../components/Icons";
import SupportActionButton from "../../../../components/SupportActionButton/SupportActionButton";

interface PetSelectionStepProps {
  selectedPets: IPetItemResponse[];
  onSelectPet: (pet: IPetItemResponse) => void;
  onSelectAll: (allPets: IPetItemResponse[]) => void;
  onContinue: () => void;
  canContinue: boolean;
}

const PetSelectionStep: FC<PetSelectionStepProps> = ({
  selectedPets,
  onSelectPet,
  onSelectAll,
  onContinue,
  canContinue,
}) => {
  const { petList } = usePetStore();
  const allSelected = (petList?.length ?? 0) > 0 && petList!.every((pet) => selectedPets.some((p) => p.id === pet.id));

  return (
    <div className="flex flex-col items-center w-full flex-1 min-h-0">
      <SupportModalHeader
        heading={COPY.STEPPER.HEADING}
        description={COPY.STEPPER.DESCRIPTION}
        filledSegments={1}
      />

      <div className="flex-1 overflow-y-auto scrollbar-thin w-full mt-4">
        <div className="border border-taupe-50 rounded-xl p-4 flex flex-col gap-4">
          <Typography
            className="grenette-pro"
            sx={{ fontSize: "18px", lineHeight: "24px", fontWeight: 600 }}
          >
            {COPY.PET_SELECTION.TITLE}
            <span className="text-red-2">*</span>
          </Typography>

          <div className="pb-4 border-b border-taupe-50">
            <div
              className="flex items-center gap-2 w-fit cursor-pointer"
              onClick={() => onSelectAll(petList ?? [])}
            >
              <Checkbox
                checked={allSelected}
                sx={{ p: 0 }}
                icon={<CheckboxUncheckedIcon />}
                checkedIcon={<CheckboxCheckedIcon />}
              />
              <Typography sx={{ fontSize: "14px", lineHeight: "14px", cursor: "pointer" }}>
                Select all
              </Typography>
            </div>
          </div>

          <div className="flex flex-col gap-3 w-full">
            {petList?.map((pet: IPetItemResponse) => (
              <div key={pet.id} className="w-full cursor-pointer" onClick={() => onSelectPet(pet)}>
                <PetCard
                  variant="compact"
                  isActive={selectedPets.some((p) => p.id === pet.id)}
                  image={pet.image}
                  pet={pet}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="w-full pt-6 shrink-0">
        <SupportActionButton
          variant="contained"
          color="primary"
          fullWidth
          disabled={!canContinue}
          onClick={onContinue}
        >
          {COPY.PET_SELECTION.CONTINUE}
        </SupportActionButton>
      </div>
    </div>
  );
};

export default PetSelectionStep;
